import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DateAggregation, ChartDto } from 'src/app/shared/models/chart.model';
import { ConfigService } from 'src/app/shared/services/config-service';
import { UseOfGoodsGroupType } from '../enums/use-of-goods-group-type.enum';
import { TimeSeriesResponseDto } from 'src/app/shared/models/time-series-response.model';
import { UserStore } from 'src/app/shared/user/store/user.store';



export interface GetUseOfGoodsParams {
  dateFrom: Date;                
  dateTo: Date;
  aggregateBy: DateAggregation;  
  useOfGoodsGroupType: UseOfGoodsGroupType;      
}

@Injectable({ providedIn: 'root' })
export class UseOfGoodsService {
  private readonly basePath = 'use-of-goods';
  
  private configService = inject(ConfigService);
  private userStore = inject(UserStore);

  constructor(private readonly http: HttpClient) {}

  getUseOfGoods(params: GetUseOfGoodsParams): Observable<TimeSeriesResponseDto> {
    let httpParams = new HttpParams()
      .set('dateFrom', this.toIsoDate(params.dateFrom))
      .set('dateTo', this.toIsoDate(params.dateTo))
      .set('aggregateBy', String(params.aggregateBy))
      .set('groupType', String(params.useOfGoodsGroupType));

    return this.http.get<TimeSeriesResponseDto>(`${this.configService.getUrlNectaOneApi()}/${this.userStore.activeTenant()?.tenantId}/${this.basePath}`, { params: httpParams });
  }
  private toIsoDate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
